import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

// Generate or retrieve visitor ID from localStorage
const getVisitorId = () => {
  let visitorId = localStorage.getItem('visitor_id');
  if (!visitorId) {
    visitorId = 'visitor_' + Date.now() + '_' + Math.random().toString(36).substr(2, 9);
    localStorage.setItem('visitor_id', visitorId);
  }
  return visitorId;
};

export const usePageTracking = () => {
  const location = useLocation();
  const startTimeRef = useRef(Date.now());
  const visitorId = getVisitorId();

  useEffect(() => {
    // Reset start time when page changes
    startTimeRef.current = Date.now();

    // Track page visit on mount
    const trackPageVisit = async () => {
      try {
        // Get device and browser information
        const deviceInfo = {
          screenWidth: window.screen.width,
          screenHeight: window.screen.height,
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          language: navigator.language,
          referrer: document.referrer || 'Direct',
          userAgent: navigator.userAgent,
          platform: navigator.platform
        };

        await fetch(`${API_URL}/track/visitor`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            visitorId,
            pageUrl: window.location.href,
            pageTitle: document.title,
            timeSpent: 0,
            deviceInfo
          }),
        });
      } catch (error) {
        console.error('Error tracking page visit:', error);
      }
    };

    trackPageVisit();

    // Track time spent on page when leaving
    const handleBeforeUnload = () => {
      const timeSpent = Math.floor((Date.now() - startTimeRef.current) / 1000); // in seconds
      
      if (timeSpent > 0) {
        navigator.sendBeacon(
          `${API_URL}/track/visitor`,
          JSON.stringify({
            visitorId,
            pageUrl: window.location.href,
            pageTitle: document.title,
            timeSpent: timeSpent,
            deviceInfo: {
              referrer: document.referrer || 'Direct'
            }
          })
        );
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
      // Track time spent when component unmounts (page change)
      const timeSpent = Math.floor((Date.now() - startTimeRef.current) / 1000);
      if (timeSpent > 0) {
        const deviceInfo = {
          screenWidth: window.screen.width,
          screenHeight: window.screen.height,
          timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
          language: navigator.language,
          referrer: document.referrer || 'Direct',
          userAgent: navigator.userAgent,
          platform: navigator.platform
        };

        fetch(`${API_URL}/track/visitor`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            visitorId,
            pageUrl: window.location.href,
            pageTitle: document.title,
            timeSpent: timeSpent,
            deviceInfo
          }),
        }).catch(err => console.error('Error tracking page time:', err));
      }
    };
  }, [location, visitorId]);
};
